<template>
  <p class="text-muted m-0 pt-1 pl-3 text-left text-sm-right">
    <small>
      Made by
      <a href="https://twitter.com/baumannzone" target="_blank">Jorge Baumann</a>
      for
      <a href="https://platzi.com/cursos/avanzado-vue/" target="_blank">Platzi</a>
    </small>
  </p>
</template>

<script>
export default {
  name: 'MadeByFoot'
}
</script>
